import React, { useState } from "react";
import { Images } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { SwipeGallery } from "../common/SwipeGallery";
import { BACKEND_URL } from "../../lib/api";

const src = (u) => (u?.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);
const hide = (e) => { e.currentTarget.style.display = "none"; };
const photosOf = (p) => (p.research?.photos || []).filter((x) => x?.url);

function Viewer({ p, photos, children, className, label, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="contents" onClick={(e) => e.stopPropagation()}>
      <button onClick={() => setOpen(true)} className={className} aria-label={label} data-testid={testid}>{children}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl sm:max-w-4xl p-4" data-testid={`lead-photos-dialog-${p.prospect_id}`}>
          <DialogHeader><DialogTitle className="font-serif text-2xl flex items-center gap-2"><Images className="w-5 h-5 text-[var(--gold)]" />{p.business_name || p.contact_name} · {photos.length} {photos.length === 1 ? "photo" : "photos"}</DialogTitle></DialogHeader>
          <SwipeGallery photos={photos} height="h-[55vh] md:h-[65vh]" testid="lead-photos-viewer" />
        </DialogContent>
      </Dialog>
    </span>
  );
}

// Photo thumbnails for a CRM lead row; click to open a full-size swipeable viewer.
export function LeadThumbs({ p, fallback }) {
  const photos = photosOf(p);
  if (!photos.length) return fallback;
  return (
    <Viewer p={p} photos={photos} label={`View ${photos.length} photos`} testid={`lead-thumb-${p.prospect_id}`}
      className="relative w-10 h-10 shrink-0 rounded-xl overflow-hidden bg-[var(--ink)] ring-1 ring-[var(--line)] hover:ring-2 hover:ring-[var(--gold)] transition-shadow">
      <img src={src(photos[0].url)} alt="" loading="lazy" onError={hide} className="w-full h-full object-cover" />
      {photos.length > 1 && <span className="absolute bottom-0 right-0 text-[9px] font-bold bg-black/70 text-white px-1 rounded-tl">{photos.length}</span>}
    </Viewer>
  );
}

export function LeadThumbStrip({ p }) {
  const photos = photosOf(p);
  if (photos.length < 2) return null;
  return (
    <Viewer p={p} photos={photos} label="Expand photos" testid={`lead-thumb-strip-${p.prospect_id}`} className="hidden lg:flex gap-1 mt-1 group/strip">
      {photos.slice(1, 4).map((x) => <img key={x.url} src={src(x.url)} alt="" loading="lazy" onError={hide} className="w-7 h-7 rounded-md object-cover ring-1 ring-[var(--line)] group-hover/strip:ring-[var(--gold)] transition-shadow" />)}
      {photos.length > 4 && <span className="w-7 h-7 rounded-md bg-[var(--bg)] text-[10px] font-bold flex items-center justify-center">+{photos.length - 4}</span>}
    </Viewer>
  );
}
